var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import RichText from '@/views/announcement/RichText/RichText1.vue';
import { getCommbookContent, validCommbookContent } from '@/common/video/commbookContent';
import AttachmentStrip from './attachment-strip.vue';
import { createConversations, getCreateTopics, searchCreateStudents } from '../api';
import { safeUrl } from '../utils';
export default Vue.extend({
    name: 'GlobalCommbookCreateConversation',
    components: { RichText: RichText, AttachmentStrip: AttachmentStrip },
    data: function () {
        return {
            query: '',
            candidates: [],
            selected: [],
            topics: [],
            topic: '',
            topicOpen: false,
            title: '',
            titleOverflow: false,
            html: '',
            files: [],
            uploads: [],
            recipientEditing: false,
            searchFocused: false,
            searching: false,
            searchError: '',
            topicsLoading: false,
            topicsError: '',
            sending: false,
            submitted: false,
            videoUploading: false,
            alive: true,
            error: '',
            searchRequest: 0,
            searchTimer: null
        };
    },
    computed: {
        contentError: function () {
            var content = getCommbookContent(this.html);
            if (content.hasInvalidMedia)
                return 'Please remove or upload the unavailable image or video again.';
            return content.characterCount > 4000 ? 'Character limit of 4000' : '';
        },
        hasAttachmentStrip: function () {
            return !!(this.files.length || this.uploads.length);
        },
        visibleSelections: function () {
            return this.recipientEditing ? this.selected : this.selected.slice(0, 2);
        },
        overflowNames: function () {
            return this.selected
                .slice(2)
                .map(function (item) { return item.name; })
                .join(', ');
        },
        titleCount: function () {
            return Array.from(this.title).length;
        },
        messageCount: function () {
            return getCommbookContent(this.html).characterCount;
        },
        hasMessage: function () {
            return getCommbookContent(this.html).hasContent;
        },
        canSend: function () {
            return (this.alive &&
                !this.sending &&
                !this.submitted &&
                !this.videoUploading &&
                !this.uploads.length &&
                !!this.selected.length &&
                !!this.topic &&
                !!this.title.trim() &&
                this.titleCount <= 200 &&
                validCommbookContent(this.html));
        }
    },
    created: function () {
        this.loadTopics();
    },
    mounted: function () {
        document.addEventListener('mousedown', this.onOutsideClick);
        window.addEventListener('resize', this.updateTitleOverflow);
    },
    beforeDestroy: function () {
        this.alive = false;
        this.sending = false;
        this.videoUploading = false;
        this.searchRequest++;
        if (this.searchTimer !== null)
            window.clearTimeout(this.searchTimer);
        document.removeEventListener('mousedown', this.onOutsideClick);
        window.removeEventListener('resize', this.updateTitleOverflow);
    },
    methods: {
        onVideoUploading: function (busy) {
            if (!this.alive || this.sending)
                return;
            this.videoUploading = busy;
        },
        onTitleInput: function () {
            this.error = '';
            this.$nextTick(this.updateTitleOverflow);
        },
        updateTitleOverflow: function () {
            var input = this.$refs.titleInput;
            this.titleOverflow = !!input && input.scrollWidth > input.clientWidth + 1;
        },
        onOutsideClick: function (event) {
            var target = event.target;
            var recipient = this.$refs.recipientField;
            var topic = this.$refs.topicField;
            if (recipient && !recipient.contains(target)) {
                this.recipientEditing = false;
                this.searchFocused = false;
            }
            if (topic && !topic.contains(target))
                this.topicOpen = false;
        },
        onRecipientFocus: function () {
            this.recipientEditing = true;
            this.searchFocused = true;
        },
        focusRecipient: function () {
            var _this = this;
            if (!this.alive || this.sending)
                return;
            this.recipientEditing = true;
            this.$nextTick(function () {
                var input = _this.$refs.recipientInput;
                if (input)
                    input.focus();
            });
        },
        onRecipientFocusOut: function () {
            var _this = this;
            this.$nextTick(function () {
                var recipient = _this.$refs.recipientField;
                if (recipient && !recipient.contains(document.activeElement)) {
                    _this.recipientEditing = false;
                    _this.searchFocused = false;
                }
            });
        },
        blurRecipient: function () {
            var input = this.$refs.recipientInput;
            if (input)
                input.blur();
            this.recipientEditing = false;
            this.searchFocused = false;
        },
        selectTopic: function (option) {
            if (!this.alive || this.sending)
                return;
            this.topic = option;
            this.topicOpen = false;
            this.error = '';
        },
        keyFor: function (student) {
            return student.studentId + ':' + student.locationId;
        },
        safePhoto: function (value) {
            return safeUrl(value);
        },
        initials: function (name) {
            return String(name || '?')
                .trim()
                .charAt(0)
                .toUpperCase();
        },
        isSelected: function (student) {
            var _this = this;
            return this.selected.some(function (item) { return _this.keyFor(item) === _this.keyFor(student); });
        },
        addStudent: function (student) {
            var _this = this;
            if (!this.alive || this.isSelected(student) || this.sending)
                return;
            this.selected.push(student);
            this.query = '';
            this.candidates = [];
            this.recipientEditing = true;
            this.searchFocused = true;
            this.searchRequest++;
            this.error = '';
            this.$nextTick(function () {
                var input = _this.$refs.recipientInput;
                if (input)
                    input.focus();
            });
        },
        removeStudent: function (student) {
            var _this = this;
            if (!this.alive || this.sending)
                return;
            this.selected = this.selected.filter(function (item) { return _this.keyFor(item) !== _this.keyFor(student); });
            this.error = '';
        },
        scheduleSearch: function () {
            var _this = this;
            this.searchRequest++;
            this.candidates = [];
            this.searchError = '';
            this.searchFocused = true;
            if (this.searchTimer !== null)
                window.clearTimeout(this.searchTimer);
            var text = this.query.trim();
            if (!text) {
                this.searching = false;
                return;
            }
            this.searching = true;
            var request = this.searchRequest;
            this.searchTimer = window.setTimeout(function () { return _this.search(text, request); }, 250);
        },
        search: function (text, request) {
            return __awaiter(this, void 0, void 0, function () {
                var results, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, 3, 4]);
                            return [4 /*yield*/, searchCreateStudents(text)];
                        case 1:
                            results = _a.sent();
                            if (!this.alive || request !== this.searchRequest)
                                return [2 /*return*/];
                            this.candidates = results;
                            return [3 /*break*/, 4];
                        case 2:
                            error_1 = _a.sent();
                            if (!this.alive || request !== this.searchRequest)
                                return [2 /*return*/];
                            this.searchError = error_1 instanceof Error ? error_1.message : 'Unable to search students.';
                            return [3 /*break*/, 4];
                        case 3:
                            if (this.alive && request === this.searchRequest)
                                this.searching = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        },
        loadTopics: function () {
            return __awaiter(this, void 0, void 0, function () {
                var topics, error_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.topicsLoading = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, getCreateTopics()];
                        case 2:
                            topics = _a.sent();
                            if (this.alive)
                                this.topics = topics;
                            return [3 /*break*/, 5];
                        case 3:
                            error_2 = _a.sent();
                            if (this.alive)
                                this.topicsError = error_2 instanceof Error ? error_2.message : 'Unable to load topics.';
                            return [3 /*break*/, 5];
                        case 4:
                            if (this.alive)
                                this.topicsLoading = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        onHtml: function (value) {
            if (!this.alive || this.sending)
                return;
            this.html = value || '';
            this.error = '';
        },
        onFile: function (value) {
            if (!this.alive || this.sending)
                return;
            var input = Array.isArray(value) ? value : [value];
            var files = input.reduce(function (result, item) {
                if (!item || typeof item !== 'object')
                    return result;
                var src = safeUrl(item.src);
                if (src)
                    result.push({
                        src: src,
                        fileName: String(item.fileName || item.name || 'Attachment'),
                        size: Number(item.size) || undefined
                    });
                return result;
            }, []);
            var completedIds = input
                .filter(function (item) { return item && item.uid != null && safeUrl(item.src); })
                .map(function (item) { return String(item.uid); });
            this.uploads = this.uploads.filter(function (upload) { return !completedIds.includes(upload.id); });
            if (Array.isArray(value))
                this.files = files;
            else if (files.length && !this.files.some(function (file) { return file.src === files[0].src; }))
                this.files.push(files[0]);
            this.error = '';
        },
        onUploadStart: function (upload) {
            if (!this.alive || this.sending)
                return;
            this.uploads.push(__assign(__assign({}, upload), { percent: null, status: 'uploading', error: '' }));
            this.error = '';
        },
        onUploadProgress: function (event) {
            if (!this.alive || this.sending)
                return;
            var upload = this.uploads.find(function (item) { return item.id === event.id; });
            if (!upload || upload.status === 'error')
                return;
            upload.percent = event.percent;
            upload.status = event.percent === 100 ? 'processing' : 'uploading';
        },
        onUploadError: function (event) {
            if (!this.alive || this.sending)
                return;
            var upload = this.uploads.find(function (item) { return item.id === event.id; });
            if (!upload)
                return;
            upload.status = 'error';
            upload.error = event.message;
        },
        removeUpload: function (id) {
            if (!this.alive || this.sending)
                return;
            this.uploads = this.uploads.filter(function (upload) { return upload.id !== id; });
        },
        removeFile: function (index) {
            if (this.alive && !this.sending)
                this.files.splice(index, 1);
        },
        setEditorEnabled: function (enabled) {
            var editor = this.$refs.editor;
            if (editor && editor.editor)
                editor.editor.setEditable(enabled);
        },
        send: function () {
            return __awaiter(this, void 0, void 0, function () {
                var created, editor, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.canSend)
                                return [2 /*return*/];
                            this.sending = true;
                            this.setEditorEnabled(false);
                            this.searchFocused = false;
                            this.topicOpen = false;
                            this.error = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, createConversations({
                                    students: this.selected.map(function (student) { return ({
                                        studentId: student.studentId,
                                        locationId: student.locationId
                                    }); }),
                                    topic: this.topic,
                                    title: this.title.trim(),
                                    message: getCommbookContent(this.html).html,
                                    attachments: this.files.slice()
                                })];
                        case 2:
                            created = _a.sent();
                            if (!this.alive)
                                return [2 /*return*/];
                            this.submitted = true;
                            this.html = '';
                            this.files = [];
                            this.uploads = [];
                            editor = this.$refs.editor;
                            if (editor && editor.clearHtml)
                                editor.clearHtml();
                            this.$emit('created', created);
                            return [3 /*break*/, 5];
                        case 3:
                            error_3 = _a.sent();
                            if (this.alive)
                                this.error = error_3 instanceof Error ? error_3.message : 'Unable to send. Please try again.';
                            return [3 /*break*/, 5];
                        case 4:
                            if (this.alive) {
                                this.sending = false;
                                this.setEditorEnabled(true);
                            }
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
    }
});
